<template>
    <div class="vx-col md:w-full sm:w-auto">
        <vx-tooltip class="position-icon" position="top" :text="$t('menuNewsEvent.onOff')"
                    v-if="isPermissionUpdateNewsEvent">
            <vs-switch v-model="turnOnOff" class="mr-4 mt-3"/>
        </vx-tooltip>

        <vx-tooltip :text="$t('button.edit')" position="top">
            <feather-icon icon="EditIcon" class="action-success mr-4"
                          svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                          @click="editRecord"/>
        </vx-tooltip>

        <vx-tooltip :text="$t('button.delete')" position="top" v-if="isPermissionDeleteNewsEvent">
            <feather-icon icon="TrashIcon" class="action-err " svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                          @click="confirmDeleteRecord"/>
        </vx-tooltip>
    </div>
</template>

<script>
import {isAPI, isRouter} from "../../../../../store/permission";
import {constAPI, constRouter} from "../../../../../store/constant";

export default {
    name: 'CellRendererActions',

    data() {
        return {
            activeStatus: true,
        }
    },
    computed: {
        turnOnOff: {
            get() {
                return this.activeStatus;
            },
            set() {
                this.turnOnOffCustomer(this.activeStatus);
            }
        }
    },
    created() {
        this.activeStatus = this.params.data.activeStatus !== 0;
    },

    methods: {
        editRecord() {
            this.$router.push(`/user/info-news-event?id=${this.params.data.id}`).catch(() => {
            })
        },
        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá ${this.params.data.type == 1 ? 'tin tức' : 'sự kiện'}: "${this.params.data.title}" không ?`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },

        deleteRecord() {
            this.$vs.loading();
            this.$crm.get(`/beauty-post/delete/${this.params.data.id}`).then(() => {
                this.$vs.loading.close();
                this.showDeleteSuccess();
                this.$store.commit('UPDATE_NEWS_EVENT', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showDeleteSuccess() {
            this.$vs.notify({
                color: 'success',
                text: 'Xoá thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        },

        turnOnOffCustomer(status) {
            this.$vs.loading();
            this.$crm.get(`/beauty-post/change-active-status/${this.params.data.id}`).then(() => {
                this.activeStatus = !status;
                this.$vs.loading.close()
                this.$vs.notify({
                    text: `${status ? this.$t('menuNewsEvent.turnOffActive') : this.$t('menuNewsEvent.turnOnActive')}`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: `${status ? 'warning' : 'success'}`
                });
                this.$store.commit('UPDATE_NEWS_EVENT', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },

        isPermissionUpdateNewsEvent() {
            return isAPI(this, constAPI.beauty_post_update);
        },

        isPermissionDeleteNewsEvent() {
            return isAPI(this, constAPI.beauty_post_update);
        },

    }
}
</script>

<style scoped></style>

